class s extends Error {
  constructor(e) {
    super(e == null ? void 0 : e.error.message), this.name = this.constructor.name;
  }
  static isNotFoundResponse(e) {
    return !(!e || typeof e != "object" || !("error" in e) || !e.error || typeof e.error != "object" || !("code" in e.error) || !("message" in e.error));
  }
}
export {
  s as NotFound
};
